<template>
    <div class="invoice-layout">
        <table class="table">
            <tr>
                <th style="border-top: none;">Item</th>
                <th style="border-top: none; width: 15%;">Net</th>
                <th style="border-top: none; width: 10%;">VAT</th>
                <th style="border-top: none; width: 5%;"></th>
                <th style="border-top: none; width: 15%">Total</th>
            </tr>
            <tbody v-if="hasInvoiceItems">
                <tr v-for="(item, i) in invoice.items">
                    <td class="truncate" style="width: 55%;">
                        <span v-if="item.quantity > 1">{{ item.quantity }} x </span>
                        {{ item.description }}
                    </td>
                    <td>{{ item.unit_cost | currency(2) }}</td>
                    <td>{{ item.unit_vat | currency(2) }}</td>
                    <td>{{ item.vat_rate }}</td>
                    <td>{{ itemTotal(i) | currency(2) }}</td>
                </tr>
            </tbody>
            <tr v-else>
                <td class="subtle" colspan="4">No invoice items</td>
            </tr>
            <tr>
                <td style="font-weight: 500">Total Price</td>
                <td style="font-weight: 500">{{ invoiceNet | currency(2) }}</td>
                <td style="font-weight: 500">{{ invoiceVat | currency(2) }}</td>
                <td></td>
                <td style="font-weight: 500">{{ invoiceTotal | currency(2) }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { InvoiceHelper } from '../../classes/Api/Invoice'
    import Filters from '../../filters'

    export default {
        filters: Filters,
        props: { invoice: {} },
        methods: {
            itemTotal(i) {
                return (new InvoiceHelper(this.invoice)).itemTotal(i);
            },
        },
        computed: {
            hasInvoiceItems() {
                return this.invoice.items.length > 0;
            },
            invoiceTotal() {
                if (this.invoice) {
                    return (new InvoiceHelper(this.invoice)).total();
                }
            },
            invoiceVat() {
                if (this.invoice) {
                    return (new InvoiceHelper(this.invoice)).vat();
                }
            },
            invoiceNet() {
                if (this.invoice) {
                    return (new InvoiceHelper(this.invoice)).net();
                }
            },
        }
    }
</script>